import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../context/locale-context';

export function useLocaleNavigate() {
  const navigate = useNavigate();
  const { localePrefix } = useLocale();

  return useCallback(
    (to, options) => {
      const path = typeof to === 'string' ? localePrefix + to : to;
      navigate(path, options);
    },
    [navigate, localePrefix]
  );
}
